var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 3,
    cy: 15.2,
    rx: 0.6,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#78909C"
    },
    cx: 3,
    cy: 15.2,
    rx: 0.4,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 4.5,
    cy: 15.2,
    rx: 0.6,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#78909C"
    },
    cx: 4.5,
    cy: 15.2,
    rx: 0.4,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.1,
    y: 15,
    style: {
      fill: "#000"
    },
    width: 3.5,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 13.3,
    cy: 15.2,
    rx: 0.6,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#78909C"
    },
    cx: 13.3,
    cy: 15.2,
    rx: 0.4,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.4,15.2c0,0.4-0.3,0.8-0.6,0.8c-0.4,0-0.6-0.4-0.6-0.8c0-0.4,0.3-0.8,0.6-0.8S15.4,14.8,15.4,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M15.2,15.2c0,0.3-0.2,0.5-0.4,0.5c-0.2,0-0.4-0.2-0.4-0.5s0.2-0.5,0.4-0.5C15,14.7,15.2,14.9,15.2,15.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 15,
    style: {
      fill: "#000"
    },
    width: 3.5,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 16.7,
    cy: 15.2,
    rx: 0.6,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M17.1,15.2c0,0.3-0.2,0.5-0.4,0.5c-0.2,0-0.4-0.2-0.4-0.5s0.2-0.5,0.4-0.5C16.9,14.7,17.1,14.9,17.1,15.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 18.2,
    cy: 15.2,
    rx: 0.6,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#78909C"
    },
    cx: 18.2,
    cy: 15.2,
    rx: 0.4,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    y: 15,
    style: {
      fill: "#000"
    },
    width: 3.5,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,11.5L21.8,11.5c-0.1,0.2-0.3,0.2-0.4,0.1l-2.1-1.9c-0.1-0.1-0.2-0.4-0.1-0.5L19.3,9 c0,0-0.1-0.1-0.1-0.1c-0.6-0.5-0.9-0.7-1.4-0.8v0.4c0,0.3-0.2,0.5-0.4,0.5H1v0.4h16.2c0.4,0,0.8,0,1.5,0.6 c0.6,0.6,1.4,1.3,2.1,1.9c1.4,1.2,1.8,0.5,1.8,0.5C22.4,12.2,22.1,11.8,21.8,11.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.8,8.5V8c-0.2,0-0.5,0-0.8,0H1v1h16.4C17.6,9,17.8,8.7,17.8,8.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.3,12c-0.5-0.4-0.9-0.4-1.2-0.4h-1.6v1.4H14v-1.4H1v2.8h15.4l0,0h2.7c1.1,0,2.4-0.1,3-0.3 c-0.6,0-1.2-0.4-1.7-0.7C19.8,13.1,19,12.5,18.3,12z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.4,
    width: 12.9,
    height: 2.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8,12.7c0-0.1-0.1-0.2-0.2-0.3c0,0-0.4,0.7-1.8-0.5c-0.7-0.6-1.5-1.4-2.1-1.9c-0.6-0.6-1-0.6-1.4-0.6 h-1.7v2.3h1.6c0.3,0,0.7,0,1.2,0.4c0.7,0.5,1.5,1.1,2.2,1.5c0.5,0.3,1.1,0.7,1.7,0.7c0.1,0,0.2,0,0.3-0.1 C22.9,13.8,23.2,13.3,22.8,12.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 11.6,
    style: {
      fill: "#000"
    },
    width: 1.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.9,
    y: 9.4,
    style: {
      fill: "#000"
    },
    width: 1.5,
    height: 2.3
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19,10l2.1,1.9c0.1,0.1,0.3,0.1,0.4-0.1l0.3-0.4c-0.8-0.9-1.9-2-2.5-2.5L19,9.4C18.9,9.6,18.9,9.8,19,10z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3,14.2c-1.1-0.1-3.2-1.2-4.2-1.2c-0.8,0-12.2,0-16.2,0v2.1h19.9c1.1,0,1.8-1.4,1.8-1.4 S22.1,14.3,21.3,14.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.3,11.2h-0.2c-0.2,0-0.4-0.2-0.4-0.4v-0.5c0-0.2,0.2-0.4,0.4-0.4h0.2c0.2,0,0.4,0.2,0.4,0.4v0.5 C17.7,11,17.5,11.2,17.3,11.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.36c572781238f6a6cb5ac57c7985144f.svg";
export { ForwardRef as ReactComponent };